import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.tags}}
  <div class="mini-tag-chooser-selected-collection selected-tags">
    {{#each this.tags as |tag|}}
      <DButton
        @translatedTitle={{tag.value}}
        @icon="times"
        @action={{fn (action this.selectKit.deselect) tag.value}}
        tabindex="0"
        class={{tag.classNames}}
      >
        {{discourse-tag tag.value noHref=true}}
      </DButton>
    {{/each}}
  </div>
{{/if}}
*/
{
  "id": "lHiv7TLR",
  "block": "[[[41,[30,0,[\"tags\"]],[[[1,\"  \"],[10,0],[14,0,\"mini-tag-chooser-selected-collection selected-tags\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"tags\"]]],null]],null],null,[[[1,\"      \"],[8,[39,3],[[24,\"tabindex\",\"0\"],[16,0,[30,1,[\"classNames\"]]]],[[\"@translatedTitle\",\"@icon\",\"@action\"],[[30,1,[\"value\"]],\"times\",[28,[37,4],[[28,[37,5],[[30,0],[30,0,[\"selectKit\",\"deselect\"]]],null],[30,1,[\"value\"]]],null]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,6],[[30,1,[\"value\"]]],[[\"noHref\"],[true]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[1]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"tag\"],false,[\"if\",\"each\",\"-track-array\",\"d-button\",\"fn\",\"action\",\"discourse-tag\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/mini-tag-chooser/selected-collection.hbs",
  "isStrictMode": false
});